<template>
  <div class="card-preload">
    <content-loader
      :height="300"
      :width="300"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="20" y="0" rx="3" ry="3" width="106" height="20" />
      <rect x="50" y="60" rx="3" ry="3" width="200" height="72" />
      <rect x="70" y="165" rx="3" ry="3" width="160" height="10" />
      <rect x="41" y="182" rx="3" ry="3" width="218" height="10" />
      <rect x="55" y="199" rx="3" ry="3" width="190" height="10" />
      <rect x="30" y="230" rx="3" ry="3" width="240" height="30" />
    </content-loader>
  </div>
</template>

<script>
export default {
  name: "CardPreload"
};
</script>

<style lang="scss">
@import "../../../components/common/styles/part/_variables.scss";
.card-preload {
  padding-top: 14px;
  border: 1px solid #f3f3f3;
}
.card-preload,
.card-preload svg {
  height: 300px;
  max-width: 300px;
  width: 100%;
}
</style>
